import React, { useState, useEffect } from "react";
import { Card, CardBody, Col, Button, Spinner } from "reactstrap";
import DataTable from "react-data-table-component";
import {
  Add,
  ViewPackagePaymentSettingTitle,
  PackagePaymentSettingTitle,
} from "../../../Utils/Constants";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
import axios from "axios";
import useCurrency, { baseUrl, mediaUrl } from "../../../Utils/FileUpload";
import { PackagePaymentSetting } from "../../../Types/Tables.type";
import FilterComponent from "../../../Components/Tables/DataTables/Common/FilterComponent";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Btn } from "../../../AbstractElements";
import { useNavigate } from "react-router-dom";

export default function ViewPackagePaymentSetting() {
  const [filterText, setFilterText] = useState("");
  const [filteredItems, setFilteredItems] = useState<PackagePaymentSetting[]>([]);
  const [refresh, setRefresh] = useState(0);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [disabledDelete, setDisabledDelete] = useState<string | null>(null);
  const [disableAllDelete, setDisableAllDelete] = useState(false);
  const token = localStorage.getItem("token");
  const { currency } = useCurrency();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${baseUrl}package_payment_setting/getall`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data: PackagePaymentSetting[] = response.data;
        // setFilteredItems(
        //   data
        //     .filter((brand) => brand.is_deleted === 0)
        //     .sort((a, b) => b.is_active - a.is_active) // 👈 actived ones first
        // );
        setFilteredItems(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [refresh]);

  const handleAdd = () => {
    navigate("/add_package_payment_setting");
  };
  const filteredData = filteredItems.filter((item: PackagePaymentSetting) => {
    const search = filterText.toLowerCase();
    return (
      item.base_amount.toString().toLowerCase().includes(search) ||
      item.base_customer_credit_point.toString().toLowerCase().includes(search) ||
      item.base_call_duration.toString().toLowerCase().includes(search) ||
      item.base_agent_point.toString().toLowerCase().includes(search) ||
      item.base_agent_payment.toString().toLowerCase().includes(search) 
    );
  });

  const handleEdit = (id: string) => {
    navigate("/edit_package_payment_setting", { state: { id: id } });
  };


  const packagePaymentSettingTableColumns = [
    {
      name: `Recharge Amount ${currency ? `(${currency})` : ""}`,
      selector: (row: PackagePaymentSetting) => row.base_amount,
      sortable: true,
      width: "19%",
    },
    {
      name: "Customer Points",
      selector: (row: PackagePaymentSetting) => row.base_customer_credit_point,
      sortable: true,
      width: "16%",
    },
    {
      name: "Call Duration (mins)",
      selector: (row: PackagePaymentSetting) => row.base_call_duration,
      sortable: true,
      width: "18%",
    },
    {
      name: "Agent Points",
      selector: (row: PackagePaymentSetting) => row.base_agent_point,
      sortable: true,
      width: "15%",
    },
    {
      name: `Agent Payment ${currency ? `(${currency})` : ""}`,
      selector: (row: PackagePaymentSetting) => row.base_agent_payment,
      sortable: true,
      width: "20%",
    },
    {
      name: "Actions",
      cell: (row: PackagePaymentSetting) => (
        <div className="d-flex justify-content-between">
          <Button
            color="primary"
            size="sm"
            onClick={() => handleEdit(row.id)}
            style={{
              marginRight: "5px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            title="Edit"
          >
            <i className="icon-pencil-alt" />
          </Button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      // button: true,
      width: "12%",
    },
  ];

  // Show a loading spinner while data is being fetched
  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spinner color="primary" />
      </div>
    );
  }
  const customStyles = {
    headCells: {
      style: {
        fontSize: "16px",
        fontWeight: "600",
        color: "#308e87",
        backgroundColor: "#f8f9fa",
        borderBottom: "2px solid #308e87",
      },
    },
    rows: {
      style: {
        borderBottom: "1px solid #dee2e6",
      },
    },
    table: {
      style: {
        border: "1px solid #dee2e6",
        borderRadius: "8px",
      },
    },
  };
  return (
    <>
      <Breadcrumbs
        pageTitle={ViewPackagePaymentSettingTitle}
        parent={PackagePaymentSettingTitle}
        title={ViewPackagePaymentSettingTitle}
      />
      <Col xl={12} className="mb-lg-3">
        <Card>
          <CardBody>
            {filteredItems.length === 0 && (
              <Col xs={12} className="mt-2 d-flex justify-content-end mb-3">
                <Btn color="primary" onClick={handleAdd}>
                  {Add}
                </Btn>
              </Col>
            )}
            <div className="table-responsive">
              <DataTable
                data={filteredData}
                columns={packagePaymentSettingTableColumns}
                pagination
                highlightOnHover
                striped
                customStyles={customStyles}
              />
            </div>
          </CardBody>
        </Card>
      </Col>
      <ToastContainer />
    </>
  );
}
